module.exports = __webpack_public_path__ + "static/record-11e219bf08f6f857d7a164553c1939ec.mp3";